const fs = require('fs');
const path = require('path');

module.exports = function setupRouting(appInstance, router) {
    appInstance.autoload = function (directory, prefix = '') {
        const walk = (dir, currentPath = '') => {
            const files = fs.readdirSync(dir);
            for (const file of files) {
                const fullPath = path.join(dir, file);
                const stat = fs.statSync(fullPath);
                if (stat.isDirectory()) {
                    walk(fullPath, `${currentPath}/${file}`);
                } else if (file.endsWith('.js')) {
                    let routePath = `${currentPath}/${file.replace('.js', '')}`;
                    routePath = routePath.replace(/\[([^\]]+)\]/g, ':$1');
                    if (routePath.endsWith('/index')) routePath = routePath.replace('/index', '');
                    if (routePath === '') routePath = '/';

                    let finalPath = prefix + routePath;
                    if (finalPath.length > 1 && finalPath.endsWith('/')) {
                        finalPath = finalPath.slice(0, -1);
                    }

                    const routeModule = require(fullPath);

                    if (typeof routeModule === 'function') {
                        router.get(finalPath, routeModule);
                    } else if (typeof routeModule === 'object') {
                        if (routeModule.get) router.get(finalPath, routeModule.get);
                        if (routeModule.post) router.post(finalPath, routeModule.post);
                        if (routeModule.put) router.put(finalPath, routeModule.put);
                        if (routeModule.delete) router.delete(finalPath, routeModule.delete);
                    }
                    console.log(`[fullstx] Autoloaded route: ${finalPath}`);
                }
            }
        };
        if (fs.existsSync(directory)) walk(directory);
        else console.warn(`[fullstx] Autoload directory not found: ${directory}`);
        return this;
    };
};
